import framework from '../framework';

// TODO: The service name is going to be generic to the onelni framework
// Change to generic name and put into constants file
const serviceName = 'ComplaintService';

// TODO: move these into config
const manifestServiceUrlFragment = 'api/Form/getForm';

/**
 * Makes a get request
 *  @param {string} url The url to GET from.
 *  @returns {Promise} The promise of the http response as json.
 */
export const get = (url) => {
    let request = framework.core.RequestBuilder.jsonRequest().endpoint(url);
    return request.fetch()
        .then((response) => response.json())
        .catch((err) => Promise.reject(new framework.errors.ResponseError(`${err.message}`)));
};

/**
 * Makes a post
 *  @param {string} url The url to post to.
 *  @param {*} body The body.
 *  @returns {Promise} The promise of the http response as json.
 */
export const post = (url, body) => {
    const requestBuilder = new framework.core.RequestBuilder()
        .method('POST')
        .bodyJson(body)
        .endpoint(url)
        .header('content-type', 'application/json');

    return requestBuilder.fetch()
        .then((response) => response.json())
        .catch((err) => Promise.reject(new framework.errors.ResponseError(`${err.message}`)));
};

/**
 * Passes and receives manifest from service
 *  @param {string} manifestName The manifest name to pass/receive.
 *  @param {string} url The url to pass to.
 *  @param {*} manifest The manifest.
 *  @param {*} parameters The parameters for the service.
 *  @returns {Promise} The promise of the http response as json.
 */
export const pass = (manifestName, url, manifest, parameters) => {
    const body = {
        formname: manifestName,
    };

    if (manifest) {
        body.element = manifest;
    }

    if (parameters) {
        body.parameters = parameters;
    }

    const gatewayBody = {
        RequestContent: JSON.stringify(body),
        ServiceName: serviceName,
        UrlData: manifestServiceUrlFragment,
        RestHttpMethod: 'POST',
    };

    return post(framework.environment.gatewayProxyUrl, gatewayBody);
};


// WEBPACK FOOTER //
// ./source/framework/api.js